// extracted by mini-css-extract-plugin
module.exports = {"clearButton":"ClearButton_clearButton__aYwd_","sidebarColors":"ClearButton_sidebarColors__0VhG2"};